import { Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { BaseComponent, HelperService, UserService } from "@mypxplat/xplat/core";
import { WebCommunityService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-community-post-detail",
  templateUrl: "community-post-detail.component.html",
})
export class CommunityPostDetailComponent extends BaseComponent {
  @Input() public betaStringId: string;
  public postId: string;
  public post: any;
  public replies: any[];
  public postNotFound: boolean;
  public postDetailRepliesSubscription: any;
  constructor(userService: UserService, public activatedRoute: ActivatedRoute, public communityService: WebCommunityService, public helperService: HelperService, private _router: Router) {
    super(userService);
  }

  ngOnInit() {
    this.postId = this.activatedRoute.snapshot.params["id"];
    if (this.postId) {
      this.getPost();
    }
  }

  getPost() {
    let isBeta = this._router.url.includes("betapost");
    this.communityService
      .getPostByID(this.postId, undefined, undefined, isBeta ? "beta_community_posts" : "community_posts")
      .then((result: any) => {
        let parentPostID = this.postId;
        if (result[0] && result[0].parentID) {
          parentPostID = result[0].parentID;
          this.communityService
            .getPostByID(parentPostID)
            .then((result: any) => {
              this.post = result[0];
              this.replies = result.filter((item) => item.parentID);
            })
            .catch((err) => {});
        } else {
          this.post = result[0];
          this.replies = result.filter((item) => item.parentID);
        }
        this.postDetailRepliesSubscription = this.communityService.watchPostReplies(parentPostID).subscribe((result) => {
          this.replies = result;
        });
      })
      .catch((err) => {
        this.postNotFound = true;
      });
  }

  goBack() {
    if (this.activatedRoute.snapshot.queryParams["searchTerm"]) {
      this._router.navigate([this.betaStringId ? "/beta/" + this.betaStringId + "/channels/all_posts" : "/community"], {
        queryParams: { search: this.activatedRoute.snapshot.queryParams["searchTerm"] },
      });
    } else {
      this._router.navigate([this.betaStringId ? "/beta/" + this.betaStringId + "/channels/all_posts" : "/community"]);
    }
  }
}
